export const CONNECTURE_CARRIER_ID = 207;
export const ALL_CONNECTURE_PLAN_TYPES = [1,2,4,256,268382208];
export const CONNECTURE_MEDICARE_TYPES = [1,2,4];
export const CONNECTURE_DSNP_TYPES = [2];
export const CONNECTURE_MEDIGAP_TYPES = [256];
export const CONNECTURE_ANCILLARY_TYPES = [268382208];
export const SNP_HAS_PERMISSION = 1;

export interface ConnectureAgent {
    /**
     * AgentID, UserName, and ExternalUserID should be the same
     */
    AgentID: string;
    UserName: string;
    ExternalUserId: string;
    
    /* Required */
    FirstName: string;
    LastName: string;
    
    /* should be empty */
    Password?: string;

    EmailAddress: string;
    PhoneNumber: string;
    Extension?: string;
    Address1: string;
    City: string;
    State: string;
    Zip: string;
    AgentRole: string;
    NPN: string;
    IsActive: number;
    ResetPasswordRequired: number;
    ExpirationDate: string;
    AgencyID?: string;
    AgencyName?: string;
}

export interface ConnectureAgentPermissionPayload {
    CarrierID: number;
    PlanYear: string;
    States: string[];
    PlanTypes: number[];
    SNPTypes: number[];
    AgentProducerID: string;
}

export interface ConnectureAgentPermissionResponse {
    CarrierID: number;
    PlanYear: number;
    State: string;
    PlanType: number;
    AgentProducerID: string;
    SNPTypes?: any[];
    StateExpirationDate?: Date | null;
}